module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// C:/Users/pc 01/AppData/Roaming/npm/node_modules/@vue/cli-service-global/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = MnUV
// module chunks = 0